import { Navigate, Route, Routes } from "react-router-dom";

import TopNav from "./components/TopNav";
import SignIn from "./pages/SignIn";
import SupplierForm from "./pages/SupplierForm";

export default function App() {
  return (
    <>
      <TopNav />
      <Routes>
        <Route path="/" element={<Navigate to="/supplier" replace />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/supplier" element={<SupplierForm />} />
        <Route path="*" element={<Navigate to="/supplier" replace />} />
      </Routes>
    </>
  );
}
